export default "__VITE_ASSET__CTu$JJD5__"